<template>
  <div style="width: 100%;">
    <input class="input-add" style="width: 50%;" :placeholder="placeholder" :disabled="isDisabled" ref="tag" type="text" v-model="tag" @keyup.enter="addTag" @click="select($refs.tag, tag)" :maxlength="maxSizeTag"/>
    <button class="secondary-button" @click="addTag" :disabled="isDisabled">Add Tag</button>
    <p v-if="showInvalidTagError">Invalid tag format</p>
    <p v-if="showMaxSizeError">Too long tag</p>
  </div>
</template>

<script>
export default {
  name: 'Tags',

  props: {
    prefix: {
      type: String,
      default: 'noprefix'
    },
    maxTags: {
      type: Number,
      default: 3
    },
    maxSizeTag: {
      type: Number,
      default: 16
    },
    placeholderActive: {
      type: String,
      default: 'Write your tag'
    },
    placeholderInactive: {
      type: String,
      default: 'Max tags reached'
    }
  },

  data() {
    return {
      tag: '',
      tags: [],
      showInvalidTagError: false,
      showMaxSizeError: false,
      isDisabled: false,
    }
  },

  computed: {
    placeholder() {
      if(this.isDisabled){
        return this.placeholderInactive
      }
      return this.placeholderActive
    },
  },

  methods: {    
    addTag() {
      this.showInvalidTagError = false
      this.showMaxSizeError = false

      if(!this.validateTag(this.tag)){
        this.showInvalidTagError = true
        return
      }

      if(this.tag.length > this.maxSizeTag){
        this.showMaxSizeError = true
        return
      }

      const exist = this.tags.indexOf(this.tag) > -1
      if(exist){
        return
      }

      this.$emit('added-tags', this.tag.trim())
      this.tags.push(this.tag.trim())
      this.tag = ''
      this.isDisabled = this.tags.length >= this.maxTags
      this.select(this.$refs.tag, this.tag)
      this.$forceUpdate()
    },

    removeTag(tag) {
      const i = this.tags.indexOf(tag) 
      const exist = i > -1
      if (exist) {
        this.tags.splice(i, 1);
      }
      this.isDisabled = this.tags.length >= this.maxTags
      this.$forceUpdate()
    },

    select(ref, model) {
      ref.focus()
      ref.setSelectionRange(0, model.length)
    },

    validateTag(tag) {
      if(tag == null || tag === ''){
        return false
      }

      return true
    },
  },
}
</script>

<style scoped>
</style>
